import React from 'react';
import {
  Card,
  Button,
  CardActions,
  CardContent,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  cardTotalCandidatos: {
    minHeight: 220,
    maxHeight: 220
  }
});

export default function TotalCandidatos(props) {
  const classes = useStyles();

  const detalhesTotalCandidatos = props.detalhesTotalCandidatos;
  let totalCandidatos = 0;

  detalhesTotalCandidatos.forEach(element => {
    totalCandidatos += element.qtd_candidatos;
  });

  return (
    <Card className={classes.cardTotalCandidatos} style={{ marginTop: 20 }}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2">
          Total de Candidatos
        </Typography>
        <Typography gutterBottom variant="h3" component="h1" align={"right"}>
          {totalCandidatos}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" color="primary" href={'/ver-candidatos'}>
          Analisar
        </Button>
      </CardActions>
    </Card>
  );
}